import { Component, Input } from '@angular/core';

@Component({
  selector: 'iho-hotel-card-skeleton',
  templateUrl: './hotel-card-skeleton.component.html',
  styleUrls: ['./hotel-card-skeleton.component.scss'],

})
export class HotelCardSkeletonComponent {

  @Input() type?: number // type = 2 will render long-height form of card

}
